import axios from 'axios'
import store from '..'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getReservationPropertyInfo ({ state }, property) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-reservation-property-info&siteid=${API.SITE_INFO.site}&property=${property}`)
        const propertyData = res.data.message.find(x => x.property === property)
        return propertyData || false
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async setReservation ({ state }, data) {
      try {
        const guestInfo = store.state.guest.guestInfo
        const siteInfo = store.state.authentication
        const spaceid = siteInfo.space
        const ota = siteInfo.public ? await store.dispatch('authentication/getOtaKey', true) : siteInfo.k
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-make-reservation',
          func: 'create',
          siteid: siteInfo.site,
          returnUrl: data.returnUrl,
          payload: {
            ...data.payload,
            ...ota && {
              userInfo: {
                ota: ota,
                ...guestInfo && {
                  ...guestInfo.stayAfter && {
                    stayAfter: guestInfo.stayAfter
                  },
                  ...guestInfo.stayBefore && {
                    stayBefore: guestInfo.stayBefore
                  }
                }
              }
            }
          },
          ...siteInfo.staff && {
            staff: siteInfo.staff
          },
          ...siteInfo.rid && {
            rid: siteInfo.rid
          },
          ...spaceid && {
            spaceid: spaceid
          },
          ...ota && {
            userInfo: {
              ota: ota,
              ...guestInfo && {
                ...guestInfo.stayAfter && {
                  stayAfter: guestInfo.stayAfter
                },
                ...guestInfo.stayBefore && {
                  stayBefore: guestInfo.stayBefore
                }
              }
            }
          }
        })
        return res
      } catch (ex) {
        return false
      }
    },
    async getReservationRealtime ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-get-reservation',
          func: 'read',
          siteid: siteInfo.site,
          spaceId: data.spaceId,
          ...data.date && {
            day: data.date
          },
          ...data.ota && {
            ota: data.ota
          }
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async getReservationInfo ({ state }, reservationId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-reservation',
          func: 'info',
          order_uuid: reservationId
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async cancelReservation ({ state }, reservationId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-reservation',
          func: 'cancel',
          order_uuid: reservationId
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    // 해당일 예약가능 여부 체크
    async checkReservationDate ({ state }, data) {
      const siteInfo = store.state.authentication
      const ota = siteInfo.k
      const rid = siteInfo.rid
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-get-reservation',
          func: 'check-reservation-date',
          siteid: siteInfo.site,
          property: data.property,
          date: data.date,
          ...ota && {
            ota: ota
          },
          ...rid && {
            rid: rid
          },
          ...siteInfo.staff && {
            staff: siteInfo.staff
          }
        })
        return (res.response && res.response.data && res.response.data.message) || res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    // 해당섹션 정보 호출
    async checkReservationSection ({ state }, data) {
      const siteInfo = store.state.authentication
      const ota = siteInfo.k
      const rid = siteInfo.rid
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-get-reservation',
          func: 'check-reservation-section',
          siteid: siteInfo.site,
          property: data.property,
          date: data.date,
          time: data.time,
          sectionId: data.section,
          ...ota && {
            ota: ota
          },
          ...rid && {
            rid: rid
          }
        })
        return (res.response && res.response.data && res.response.data.message) || res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    // 예약 가능한지 체크
    async checkReservation ({ state }, data) {
      const siteInfo = store.state.authentication
      const ota = siteInfo.k
      const rid = siteInfo.rid
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-get-reservation',
          func: 'check-reservation',
          siteid: siteInfo.site,
          property: data.property,
          date: data.date,
          time: data.time,
          seats: data.seats,
          ...ota && {
            ota: ota
          },
          ...rid && {
            rid: rid
          }
        })
        return (res.response && res.response.data && res.response.data.message) || res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    // test
    async deleteReservation ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-test',
          func: 'deleteAll',
          siteid: siteInfo.site,
          spaceId: data.spaceId,
          ...(data.date) && {
            day: data.date
          }
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    // test
    async deleteReservationItem ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-test',
          func: 'deleteOne',
          siteid: siteInfo.site,
          spaceId: data.spaceId,
          order_uuid: data.orderId
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    }
  },
  getters: {
    getReservationResultData: () => (code) => {
      let result = true
      switch (code) {
        case 201:
          result = 'already_self' // 동일 시간 예약 오류
          break
        case 202:
          result = 'canceled' // 이미 취소된 예약
          break
        case 203:
          result = 'refresh' // 새로고침 필요(변경사항 발생)
          break
        case 204:
          result = 'overbooking' // 오버부킹(예약이 모두 참)
          break
        case 205:
          result = 'aleady' // 이미 예약된 좌석
          break
        case 301:
          result = 'disabled' // 현재 예약불가
          break
        case 302:
          result = 'permission' // 예약 권한이 없음
          break
        case 303:
          result = 'limit' // 예약 횟수 초과
          break
        case 304:
          result = 'cancel_impossible' // 예약 취소 불가
          break
        case 305:
          result = 'cancel_timeout' // 예약 취소 시간 초과
          break
        case 306:
          result = 'disabled_time' // 예약 가능한 시간이 아님
          break
        case 401:
          result = 'nodata_reservation' // 예약내역이 없음
          break
        case 402:
          result = 'invalid_reservation' // 유효하지 않은 예약정보
          break
        case 404:
          result = 'nodata' // 설정정보가 없음
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
        case 501:
          result = 'wrong_parameter' // 잘못된 파라미터
          break
        case 502:
          result = 'wrong_property' // 잘못된 설정값
          break
      }
      return result
    }
  }
}
